import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query'

import getApiToken from '../../../lib/getApiToken'
import storage from '../../../common/utils/storage'
import { reset } from '../features/user/userSlice'

const dynamicBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, { baseUrl: string }> = async (
    args,
    api,
    extraOptions
) => {
    const baseUrl = extraOptions.baseUrl
    const rawBaseQuery = fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers) => {
            const token = getApiToken()
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    })
    return rawBaseQuery(args, api, extraOptions)
}

export const baseQueryWithReauth: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError,
    { baseUrl: string }
> = async (args, api, extraOptions) => {
    const result = await dynamicBaseQuery(args, api, extraOptions)

    if (result && result.error && result.error.status === 401) {
        storage.removeItem('token')
        api.dispatch(reset())
    }
    return result
}

export function isFetchBaseQueryError(error: unknown): error is FetchBaseQueryError {
    return typeof error === 'object' && error != null && 'status' in error
}
